'use client'

import { Input } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputFirstName: SBDynamicFormInput = ({ ...rest }) => {
  return <Input {...rest} autoComplete="given-name" />
}

export { SBDynamicFormInputFirstName }
